// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RcZj","title":"styles_title__2sVmM"};